import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { HandleReactComponentRendering } from '@ClientBase/React/RenderReactComponents'
import { declareClientPackage, RuntimeDetails } from '@ClientBase/IClientPackage'
import { JobFiltersEventHandler } from '@ClientBase/Generic/JobFiltersEventHandler'
import { PostFiltersEventHandler } from '@ClientBase/Generic/PostFiltersEventHandler'
import { BurgerMenuEventHandler } from '@ClientBase/Generic/BurgerMenuEventHandler'
import * as Carousels from './Carousels'
import * as VideoSnippet from './VideoSnippet'
import * as DomMainipulations from './DomMainipulations'
import * as Navigation from './Navigation'
import * as BrowserJobsOVerlay from './BrowseJobsOverlay'
import * as Filters from './Filters'
import * as StickyApply from './StickyApply'
import * as JobTile from './JobTile'
import * as Modal from './Modal'
import * as PostTile from './PostTile'
import * as ListWidget from './ListWidget'
import * as SocialProfile from './SocialProfileWidget'
import * as Footer from './Footer'
import SnippetSpacer from './Spacer/Spacer'
import SnippetHeading from './Heading/Heading'
import SnippetContent from './Content/Content'
import SnippetImageContent from './ImageContent/ImageContent'
import SnippetContentColumn from './ContentColumn/ContentColumn'
import SnippetLinkBox from './LinkBox/LinkBox'
import SnippetTabSwitcher from './TabSwitcher/TabSwitcher'
import SnippetIconsText from './IconsText/IconsText'
import SnippetAccordionReact from './Accordion/Accordion'
import SnippetVideo from './Video/Video'
import {HoverCardGrid} from './HoverCardGrid/HoverCardGrid'
import {SocialBanner} from './SocialBanner/SocialBanner'
import {ExpandableCardsGrid} from './ExpandableCardsGrid/ExpandableCardsGrid'
import {StayInTouch} from './StayInTouch/StayInTouch'
import {Timeline} from './Timeline/Timeline'
import {Statistics} from './Statistics/Statistics'
import {Quote} from './Quote/Quote'

/**
 * Extend the ClientBase class so you can benefit from any event hooks that Attrax offers,
 * and so that Attrax knows you have defined specific methods
 */

const _Components = {
    'SnippetSpacer': SnippetSpacer,
    'SnippetHeading': SnippetHeading,
    'SnippetContent' : SnippetContent,
    'SnippetImageContent': SnippetImageContent,
    'SnippetContentColumn': SnippetContentColumn,
    'SnippetLinkBox': SnippetLinkBox,
    'SnippetTabSwitcher': SnippetTabSwitcher,
    'SnippetIconsText' : SnippetIconsText,
    'SnippetAccordion' : SnippetAccordionReact,
    'SnippetVideo' : SnippetVideo,
    'HoverCardGrid': HoverCardGrid,
    'SocialBanner': SocialBanner,
    'ExpandableCardsGrid': ExpandableCardsGrid,
    'StayInTouch': StayInTouch,
    'Timeline': Timeline,
    'Statistics': Statistics,
    'Quote': Quote,
}


declareClientPackage({
    onCmsSnippetPreview() {
        HandleReactComponentRendering(React, ReactDOM, _Components)
    },
    onDocumentReady(details: RuntimeDetails) {
        HandleReactComponentRendering(React, ReactDOM, _Components)
        Navigation.navigationFunctions()
        DomMainipulations.removeSocialWidgetIfEmpty()
        JobFiltersEventHandler.useAttraxTsHandlers($)
        PostFiltersEventHandler.useAttraxTShandler($)
        BurgerMenuEventHandler.handleClickEvents($)
        VideoSnippet.VideoClickHandler()
        DomMainipulations.homePageScroll($)
        DomMainipulations.moveLinkedInButton($)
        DomMainipulations.moveFilterButton($)
        DomMainipulations.repositionBioModal($)
        DomMainipulations.shortlistRedirect($)
        DomMainipulations.showValidationIfTrue($)
        DomMainipulations.createStickyApplyHeading($)
        DomMainipulations.moveKeyword()
        DomMainipulations.moveSendCvModal($)
        DomMainipulations.removeFooterAutocomplete($)
        DomMainipulations.showExpiredVacancyBanner($)
        DomMainipulations.addClearbtn()
        DomMainipulations.removeNonBreakingSpaceFromJobDetails()
        DomMainipulations.addFilterTextHeadingJobResults()
        DomMainipulations.showAuthorDetailsIfAuthor()
        Carousels.initialise()
        Filters.scrollHandler($)
        Filters.jobFiltersLocationClickHandler();
        Filters.postFiltersBtnClickHandler();
        StickyApply.showStickyApply()
        JobTile.addLogo()
        JobTile.logoReplacer()
        JobTile.brandClassAssignment()
        JobTile.setActive()
        Modal.closeModalOnBgClick()
        PostTile.makePostTileClickable()
        ListWidget.checkIfJobTilesHaveProfile()
        SocialProfile.displayRecruiterIfAvailable()
        BrowserJobsOVerlay.BrowseJobsOverlay()
        Footer.FooterHandlers()
        $(document).on('job-filter-initialized', function () {
            (window as any).jobFilterNoReloadController.enableDefaultFilterCounts()
        })
    }
})
